module.exports = "<div class=\"page-ymb-detail ymb\">\r\n    <sku-info></sku-info>\r\n    <brand-info></brand-info>\r\n    <spec-info></spec-info>\r\n    <feature-list></feature-list>\r\n    <ymb-legs></ymb-legs>\r\n    <knowledge-info :isSkuYmb=\"true\"></knowledge-info>\r\n    <more-products></more-products>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/page/ymb-page-content.html
// module id = 277
// module chunks = 0